<template>
  <form>
    <v-subheader>{{labels.appID}}</v-subheader>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['motorClaim'])">
          <v-card :class="claimForm.appID === constAppID.MOTOR ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doAppID(constAppID.MOTOR)">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.MOTOR}}</v-icon>
              <span>Motor</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['travelClaim'])">
          <v-card :class="claimForm.appID === constAppID.TRAVEL ? 'quoteCard cardActive' : 'quoteCard'" @click.native="doAppID(constAppID.TRAVEL)">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.TRAVEL}}</v-icon>
              <span>Travel</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['fireClaim'])">
          <v-card :class="claimForm.appID === constAppID.FIRE ? 'quoteCard cardActive' : 'quoteCard'" @click.native="claimForm.appID = constAppID.FIRE">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.FIRE}}</v-icon>
              <span>Fire</span>
            </v-layout>
          </v-card>
        </v-flex>
        <!-- <v-flex lg2 md3 xs6 v-if="checkAccess(['paClaim'])">
          <v-card :class="claimForm.appID === constAppID.PA ? 'quoteCard cardActive' : 'quoteCard'" @click.native="claimForm.appID = constAppID.PA">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.PA}}</v-icon>
              <span>Personal Accident</span>
            </v-layout>
          </v-card>
        </v-flex> -->
        <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoClaim'])">
          <v-card :class="claimForm.appID === constAppID.CARGO ? 'quoteCard cardActive' : 'quoteCard'" @click.native="claimForm.appID = constAppID.CARGO">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.CARGO}}</v-icon>
              <span>Cargo</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['maidClaim'])">
          <v-card :class="claimForm.appID === constAppID.MAID ? 'quoteCard cardActive' : 'quoteCard'" @click.native="claimForm.appID = constAppID.MAID">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.MAID}}</v-icon>
              <span>Maid</span>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex lg2 md3 xs6 v-if="checkAccess(['packageClaim'])">
          <v-card :class="claimForm.appID === constAppID.PACKAGE ? 'quoteCard cardActive' : 'quoteCard'" @click.native="claimForm.appID = constAppID.PACKAGE">
            <v-layout fill-height column justify-center align-center>
              <v-icon>{{appIcon.PACKAGE}}</v-icon>
              <span>Package</span>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row wrap class="mt-3">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex md12>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-subheader>{{labels.claimInfo}}</v-subheader>
                    </v-flex>
                    <v-flex xs12>
                      <message :messages="messages"></message>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="claimForm.proposalNo" :label="labels.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="labels.proposalNo" v-validate="'numeric'" @change="getProposal(claimForm.proposalNo)">
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="doShowProposals" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-text-field v-model="claimForm.polNo" :label="labels.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="labels.polNo" v-validate="'required|entry|max:16'" @change="getProposalByPolNo(claimForm.polNo)" :hint="hasClaimHint()" :persistent-hint="true" :class="getHasClaimHintClass()">
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="doShowProposals" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <cal-picker v-model="claimForm.lossDate" :label="labels.lossDate" v-validate="lossDateValidation" :min="minLossDate" :max="maxLossDate" :data-vv-as="labels.lossDate" data-vv-name="lossDate" :error-messages="errors.collect('lossDate')" :hint="getLossDateHint(claimForm.lossDate)" :persistent-hint="true" :class="getLossDateClass()"></cal-picker>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <cal-picker v-model="claimForm.notDate" :label="labels.notDate" v-validate="notDateValidation" :data-vv-as="labels.notDate" data-vv-name="notDate" :error-messages="errors.collect('notDate')" :min="minNotDate" :max="maxNotDate"></cal-picker>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <cal-picker v-model="claimForm.ackDate" :label="labels.ackDate" v-validate="ackDateValidation" :data-vv-as="labels.ackDate" data-vv-name="ackDate" :error-messages="errors.collect('ackDate')" :min="minAckDate"></cal-picker>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-subheader class="queryLabel">{{labels.periodOfCover}}</v-subheader>
                      <div>{{ periodOfCover }}</div>
                    </v-flex>
                    <v-flex lg6 xs12>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field v-int-mask="{intScale: 3}" v-model="claimForm.riskNo" :label="labels.riskNo" type="tel" :error-messages="errors.collect('riskNo')" data-vv-name="riskNo" :data-vv-as="labels.riskNo" v-validate="'required|numeric|max_value:999|min_value:1'"></v-text-field>
                        </v-flex>
                        <v-flex xs6 v-if="claimForm.appID === 'MO'">
                          <v-text-field v-int-mask="{intScale: 3}" v-model="claimForm.itemNo" :label="labels.itemNo" type="tel" :error-messages="errors.collect('itemNo')" data-vv-name="itemNo" :data-vv-as="labels.itemNo" v-validate="'required|numeric|max_value:999|min_value:1'"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex lg6 xs12 v-if="claimForm.appID === 'TR'">
                      <v-subheader class="queryLabel">{{labels.acceptDate}}</v-subheader>
                      <div>{{formatDate(claimForm.acceptDate)}}</div>
                    </v-flex>
                    <v-flex lg6 xs12 v-else-if="claimForm.appID === 'MO'">
                      <v-subheader class="queryLabel">{{labels.vehRegNo}}</v-subheader>
                      <div>{{claimForm.vehRegNo}}</div>
                    </v-flex>
                    <v-flex lg6 xs12 v-if="claimForm.appID === 'MO'">
                      <cal-picker v-model="claimForm.reqDate" :label="labels.reqDate" :data-vv-as="labels.reqDate" data-vv-name="reqDate" :error-messages="errors.collect('reqDate')"></cal-picker>
                    </v-flex>
                    <v-flex lg6 xs12 v-if="claimForm.appID === 'MO'">
                      <cal-picker v-model="claimForm.recDate" :label="labels.recDate" :data-vv-as="labels.recDate" data-vv-name="recDate" :error-messages="errors.collect('recDate')"></cal-picker>
                    </v-flex>
                    <v-flex xs12 v-if="claimForm.appID === 'MO'">
                      <v-text-field v-model="claimForm.lossPlace" :label="labels.lossPlace" type="tel" :error-messages="errors.collect('lossPlace')" data-vv-name="lossPlace" :data-vv-as="labels.lossPlace" v-validate="'entry|max:100'"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="claimForm.cseLoss1" :label="labels.cseLoss1" type="tel" :error-messages="errors.collect('cseLoss1')" data-vv-name="cseLoss1" :data-vv-as="labels.cseLoss1" v-validate="'required|entry|max:35'"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="claimForm.cseLoss2" :label="labels.cseLoss2" type="tel" :error-messages="errors.collect('cseLoss2')" data-vv-name="cseLoss2" :data-vv-as="labels.cseLoss2" v-validate="'entry|max:35'"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="claimForm.cseLoss3" :label="labels.cseLoss3" type="tel" :error-messages="errors.collect('cseLoss3')" data-vv-name="cseLoss3" :data-vv-as="labels.cseLoss3" v-validate="'entry|max:35'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-btn color="primary" type="submit" large :loading="$store.state.claims.claimDetail.saving" @click.prevent="doProceed(false)">
                      Proceed
                      <v-icon right dark>mdi-playlist-check</v-icon>
                    </v-btn>
                    <v-btn color="primary" type="submit" large :loading="$store.state.claims.claimDetail.saving" @click.prevent="doProceed(true)" v-if="checkAccess(['motorClaimCore', 'travelClaimCore'])">
                      Convert From Odyssey
                      <v-icon right dark>mdi-format-list-checks</v-icon>
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex lg4 hidden-md-and-down>
              </v-flex>
            </v-layout>
            <v-dialog v-model="showProposals" width="1280px">
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Proposals
                  <v-spacer></v-spacer>
                  <v-btn flat icon @click="showProposals = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-flex xs12>
                    <form data-vv-scope="queryProposalFilterForm">
                      <v-expansion-panel expand :value="[true]">
                        <v-expansion-panel-content>
                          <div slot="header">
                            <v-icon>mdi-filter-variant</v-icon> Filters
                          </div>
                          <v-card>
                            <v-card-text>
                              <v-container fluid grid-list-lg>
                                <v-layout row wrap>
                                  <v-flex lg6 xs12>
                                    <v-text-field data-vv-scope="queryProposalFilterForm" v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                                  </v-flex>
                                  <v-flex lg6 xs12>
                                    <v-text-field data-vv-scope="queryProposalFilterForm" v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('filterPolNo')" data-vv-name="filterPolNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                                  </v-flex>
                                  <v-flex lg6 xs12>
                                    <cal-picker data-vv-scope="queryProposalFilterForm" v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                                  </v-flex>
                                  <v-flex lg6 xs12>
                                    <cal-picker data-vv-scope="queryProposalFilterForm" v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions right>
                              <v-spacer></v-spacer>
                              <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                              <v-btn color="primary" flat="flat" @click.prevent="doFilters">Apply Filters</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </form>
                  </v-flex>
                  <v-flex xs12 class="mt-2">
                    <v-data-table :headers="this.headers" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.proposalNo }}</td>
                        <td>{{ props.item.polNo }}</td>
                        <td>{{ props.item.intermediaryName }}</td>
                        <td>{{ props.item.appName }}</td>
                        <td>{{ props.item.createdDate }}</td>
                        <td align='center'>
                          <v-btn icon slot="activator" color="primary" flat type="submit" @click.prevent="doSelectProposal(props.item.proposalNo)">
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import clone from 'clone'
import { mapGetters } from 'vuex'
import { CLAIMS_CLAIMDETAIL_RESET } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { appID, appIcon } from '@/const/underwriting'
import { expandURI, filterQuery } from '@/utils/ajax'
import { removeTime, setEndTime, formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'
import * as TableConst from '@/mixins/table'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      labels: {
        appID: 'Claim Type',
        claimInfo: 'Claim Information',
        proposalNo: 'Proposal No.',
        polNo: 'Policy No.*',
        lossDate: 'Loss Date*',
        notDate: 'Notification Date*',
        ackDate: 'Acknowledge Date*',
        reqDate: 'Required Date',
        recDate: 'Received Date',
        lossPlace: 'Loss Place',
        periodOfCover: 'Period of Cover',
        acceptDate: 'Policy Acceptance Date',
        vehRegNo: 'Vehicle Registration No.',
        riskNo: 'Policy Benefit Section*',
        itemNo: 'Item No*',
        cseLoss1: 'Cause of Loss*',
        cseLoss2: '',
        cseLoss3: ''
      },
      claimForm: {
        appID: undefined,
        proposalNo: undefined,
        polNo: undefined,
        lossDate: undefined,
        ackDate: undefined,
        notDate: undefined,
        comDate: undefined,
        expDate: undefined,
        acceptDate: undefined,
        vehRegNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        reqDate: undefined,
        recDate: undefined,
        lossPlace: undefined,
        cseLoss1: undefined,
        cseLoss2: undefined,
        cseLoss3: undefined,
        claimFromCore: false
      },
      headers: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Intermediary', value: 'interName' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        polNo: 'Policy No.',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To'
      },
      filters: {
        proposalNo: null,
        polNo: null,
        entryFrom: null,
        entryTo: null
      },
      totalItems: 0,
      showProposals: false,
      lossDateWarning: false,
      hasClaimWarning: false,
      hasClaimText: null
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    constAppID() {
      return appID
    },
    appIcon() {
      return appIcon
    },
    minLossDate() {
      if (this.claimForm.comDate !== undefined) {
        let result
        result = this.claimForm.comDate
        return result
      }
      return undefined
    },
    maxLossDate() {
      if (this.claimForm.expDate !== undefined) {
        let result
        result = this.claimForm.expDate
        return result
      }
      return undefined
    },
    minNotDate() {
      if (this.claimForm.lossDate !== undefined) {
        let result
        result = this.claimForm.lossDate
        return result
      }
      return undefined
    },
    maxNotDate() {
      let result = new Date()
      return result
    },
    minAckDate() {
      if (this.claimForm.notDate !== undefined) {
        let result
        result = this.claimForm.notDate
        return result
      }
      return undefined
    },
    lossDateValidation() {
      if (this.claimForm.appID === 'MO') {
        const result = 'required|claims_lossDate_comDate:' + this.claimForm.comDate + '|claims_lossDate_expDate:' + this.claimForm.expDate
        return result
      } else {
        return 'required'
      }
    },
    notDateValidation() {
      const result = 'required|claims_notDate_lossDate:' + this.claimForm.lossDate + '|claims_notDate_today'
      return result
    },
    ackDateValidation() {
      const result = 'required|claims_ackDate_notDate:' + this.claimForm.notDate
      return result
    },
    periodOfCover() {
      if (this.claimForm.comDate != null && this.claimForm.expDate != null) {
        return this.formatDate(this.claimForm.comDate) + ' - ' + this.formatDate(this.claimForm.expDate)
      } else {
        return ''
      }
    }
  },
  watch: {
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  mounted() {
    // Start of claims to reset claim state
    this.$store.commit(CLAIMS_CLAIMDETAIL_RESET)
  },
  methods: {
    doInit() {
      // Init
      this.claimForm.lossDate = undefined
      this.claimForm.proposalNo = undefined
      this.claimForm.polNo = undefined
      this.claimForm.comDate = undefined
      this.claimForm.expDate = undefined
      this.claimForm.acceptDate = undefined
      this.claimForm.notDate = undefined
      this.claimForm.ackDate = undefined
      this.claimForm.riskNo = 0
      this.claimForm.itemNo = 0
      this.claimForm.cseLoss1 = undefined
      this.claimForm.cseLoss2 = undefined
      this.claimForm.cseLoss3 = undefined
      this.lossDateWarning = false
      this.hasClaimWarning = false
    },
    doAppID(selectedAppID) {
      this.claimForm.appID = selectedAppID
      this.doInit()
    },
    doShowProposals() {
      if (!this.claimForm.appID) {
        this.$snotify.error('Please select a Claim Type')
      } else {
        this.showProposals = true
        this.$set(this, 'items', [])
        this.fetchData()
      }
    },
    doClearFilters() {
      this.filters.polNo = null
      this.filters.proposalNo = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryProposalFilterForm').then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async fetchData() {
      const apiUrl = this.$store.state.claims.claimEntry.menu.proposalList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            appID: this.claimForm.appID,
            page: page - 1,
            size: rowsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              data.map(row => {
                if (row.createdDate) {
                  row.createdDate = this.formatDate(row.createdDate)
                }
              })
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSelectProposal(selectedProposalNo) {
      this.claimForm.proposalNo = selectedProposalNo
      this.getProposal(this.claimForm.proposalNo, true)
      this.showProposals = false
    },
    async getProposal(proposalNo) {
      if (!this.claimForm.appID) {
        this.$snotify.error('Please select a Claim Type')
        this.claimForm.proposalNo = undefined
      } else {
        const apiURI = this.$store.state.claims.claimEntry.menu.getProposal
        if (apiURI) {
          this.proposalLoading = true
          if (proposalNo !== undefined && proposalNo !== null && proposalNo !== '') {
            try {
              const expand = {
                proposalNo: removeFormatNumber(proposalNo),
                appID: this.claimForm.appID
              }
              const result = await this.$http.get(expandURI(apiURI, expand))
              if (result.data) {
                if (result.data.polNo) {
                  this.claimForm.polNo = result.data.polNo
                  this.hasClaim(this.claimForm.polNo)
                  this.claimForm.comDate = result.data.comDate
                  this.claimForm.expDate = result.data.expDate
                  this.claimForm.acceptDate = result.data.acceptDate
                  if (this.claimForm.appID === 'MO') {
                    this.claimForm.vehRegNo = result.data.vehRegNo
                  }
                  this.proposalLoading = false
                  this.$validator.reset()
                } else {
                  this.doInit()
                  this.proposalLoading = false
                  this.$snotify.error('This Proposal has not been converted to Policy')
                }
              } else {
                this.doInit()
                this.proposalLoading = false
                this.$snotify.error('Invalid Proposal No.')
              }
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.fieldMessage(data)
                this.notify(data)
              }
              this.doInit()
              this.proposalLoading = false
            }
          } else {
            this.doInit()
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      }
    },
    hasClaimHint() {
      if (this.hasClaimWarning) {
        return 'A Claim has been filed for this Policy No.'
      } else {
        return ''
      }
    },
    async hasClaim(polNo) {
      const apiURI = this.$store.state.claims.claimEntry.menu.hasClaim
      if (apiURI) {
        if (polNo !== undefined && polNo !== null && polNo !== '') {
          const expand = {
            polNo: polNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.hasClaimWarning = true
          } else {
            this.hasClaimWarning = false
          }
        } else {
          this.hasClaimWarning = false
        }
      } else {
        this.hasClaimWarning = false
      }
    },
    async getProposalByPolNo(polNo) {
      if (!this.claimForm.appID) {
        this.$snotify.error('Please select a Claim Type')
        this.claimForm.polNo = undefined
      } else {
        if (this.checkAccess(['motorClaimCore']) || this.checkAccess(['travelClaimCore'])) {
          this.hasClaim(polNo)
        } else {
          const apiURI = this.$store.state.claims.claimEntry.menu.getProposalByPolNo
          if (apiURI) {
            this.proposalLoading = true
            if (polNo !== undefined && polNo !== null && polNo !== '') {
              try {
                const expand = {
                  polNo: polNo,
                  appID: this.claimForm.appID
                }
                const result = await this.$http.get(expandURI(apiURI, expand))
                if (result.data) {
                  this.claimForm.proposalNo = result.data.proposalNo
                  this.claimForm.polNo = result.data.polNo
                  this.claimForm.comDate = result.data.comDate
                  this.claimForm.expDate = result.data.expDate
                  this.claimForm.acceptDate = result.data.acceptDate
                  if (this.claimForm.appID === 'MO') {
                    this.claimForm.vehRegNo = result.data.vehRegNo
                  }
                  this.proposalLoading = false
                  this.$validator.reset()
                } else {
                  this.doInit()
                  this.proposalLoading = false
                  this.$snotify.error('Invalid Proposal No.')
                }
              } catch (err) {
                const { data } = err.response
                if (data) {
                  this.fieldMessage(data)
                  this.notify(data)
                }
                this.doInit()
                this.proposalLoading = false
              }
              this.hasClaim(polNo)
            } else {
              this.doInit()
            }
          } else {
            this.$snotify.error('Invalid API URL')
          }
        }
      }
    },
    doProceed(claimFromCore) {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Manual validation here
          if (!this.claimForm.appID) {
            this.$snotify.error('Please select a Claim Type')
          } else {
            this.claimForm.claimFromCore = claimFromCore
            this.doSave()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doSave() {
      this.$store.dispatch('createClaim', this.claimForm)
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    getLossDateHint(lossDate) {
      if (this.claimForm.appID === 'TR') {
        if (lossDate) {
          if (this.claimForm.comDate && this.claimForm.expDate) {
            if (isAfter(removeTime(this.claimForm.comDate), removeTime(lossDate)) || isAfter(removeTime(lossDate), removeTime(this.claimForm.expDate))) {
              this.lossDateWarning = true
              return 'This Loss Date is not covered.'
            } else {
              this.lossDateWarning = false
              return ''
            }
          }
        } else {
          this.lossDateWarning = false
          return ''
        }
      } else {
        this.lossDateWarning = false
        return ''
      }
    },
    getLossDateClass() {
      if (this.lossDateWarning) {
        return 'lossDateWarning'
      } else {
        return ''
      }
    },
    getHasClaimHintClass() {
      if (this.hasClaimWarning) {
        return 'hasClaimWarning'
      } else {
        return ''
      }
    }
  },
  created() {
    // Load in local field validation
    // Name must be unique (as it will extend throughout the application)
    this.$validator.extend('claims_lossDate_comDate', {
      getMessage(field, args) {
        return `The ${field} is not covered.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var comDate = args[0]
          if (comDate) {
            if (isAfter(removeTime(comDate), removeTime(value))) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_lossDate_expDate', {
      getMessage(field, args) {
        return `The ${field} is not covered.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var expDate = args[0]
          if (expDate) {
            if (isAfter(removeTime(value), removeTime(expDate))) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_notDate_lossDate', {
      getMessage(field, args) {
        return `The ${field} cannot be earlier than Loss Date.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var lossDate = args[0]
          if (lossDate) {
            if (isAfter(removeTime(lossDate), removeTime(value))) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_notDate_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than Today.`
      },
      validate(value, args) {
        if (value) {
          if (isAfter(removeTime(value), removeTime(new Date()))) return false
          else return true
        } else return true
      }
    })
    this.$validator.extend('claims_ackDate_notDate', {
      getMessage(field, args) {
        return `The ${field} cannot be earlier than Notification Date.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var notDate = args[0]
          if (notDate) {
            if (isAfter(removeTime(notDate), removeTime(value))) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.doInit()
  },
  mixins: [
    MessageMixin,
    TableConst.default
  ]
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";

.prospectHelp {
  min-height: 550px;
}

.lossDateWarning {
  .v-messages__message {
    color: $error !important;
  }
}

.hasClaimWarning {
  .v-messages__message {
    color: $error !important;
  }
}
</style>
